import React from 'react'
import { useInviteUserMutation } from '../../../../../store/apis/user.api'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import UserForm from '../UserForm'
import { useFetchOrganizationsQuery } from '../../../../../store/apis/organization.api'
import { UserRoles } from '../../../../../constants'
import useAuthorization from '../../../../../components/authorization/useAuthorization'
import { useSelector } from 'react-redux'
import userSelectors from '../../../../../store/selectors/user.selectors'

const InviteUserForm = ({ onSuccess }) => {
    const [inviteUser, inviteUserResult] = useInviteUserMutation()
    const { isAuthorized: isSystemAdmin } = useAuthorization([UserRoles.SYSTEM_ADMIN])
    const { isAuthorized: isAdmin } = useAuthorization([UserRoles.ADMIN])
    const { isAuthorized: isUserManager } = useAuthorization([UserRoles.USER_MANAGER])
    const canAssignOrganization = isSystemAdmin || isAdmin || isUserManager
    
    const { data: organizations, isFetching: isFetchingOrganizations } = useFetchOrganizationsQuery(null, { skip: !canAssignOrganization })
    const currentUserEmail = useSelector(userSelectors.email)

    const handleInviteUser = async values => {
        // Check if user is trying to invite themselves
        if (values.email && currentUserEmail && values.email.toLowerCase() === currentUserEmail.toLowerCase()) {
            openNotificationWithIcon('error', 'You cannot invite yourself. Please enter a different email address.')
            return
        }

        const response = await inviteUser(values)

        if ('data' in response) {
            openNotificationWithIcon('success', `User was invited successfully. An email has been sent to <code>${values.email}</code> with instructions to set up their account.`)
            onSuccess && onSuccess()
        }
    }

    const fieldsToHide = canAssignOrganization ? ['status', 'password', 'name'] : ['status', 'password', 'name', 'organizationId']

    return (
        <UserForm
            organizations={organizations}
            isFetchingOrganizations={isFetchingOrganizations}
            onSubmit={handleInviteUser}
            loading={inviteUserResult.isLoading}
            error={inviteUserResult.error}
            fieldsToHide={fieldsToHide}
            actionName='Invite'
        />
    )
}

export default InviteUserForm
